<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-敏感词-修改
    -->
    <el-dialog
    title="修改敏感词"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改敏感词</div>

        <el-form-item label="敏感词名称" prop="name"><el-input v-model="form.name" placeholder="请输入敏感词名称" class="max-w460"></el-input></el-form-item>

        <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>

</template>

<script>
import Sensitive_wordApi from '@/api/sensitive_word.js';
export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入敏感词名称', trigger: 'blur' }],
      },
      dialogVisible:false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","sensitive_word_id"],
  methods: {
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      Sensitive_wordApi.detail({sensitive_word_id: self.sensitive_word_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.sensitive_word_id = self.sensitive_word_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Sensitive_wordApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/sensitive_word/index/part/edit.vue